import { buildDropdownList } from '../util/app/app.helpers'

const NFT_TYPES_OPTION_DATA = {
  membership: 'membership',
  badge: 'badge',
  status: 'status',
  collectible: 'collectible',
  perk: 'perk',
  redeemable_reward: 'redeemable-reward',
  ticket: 'ticket',
  invitation: 'invitation'
}

const NFT_SORTING_OPTIONS = {
  newest: 'newest-first',
  alphabetical: 'alphabetical'
}

export const NFT_STATUS_OPTIONS = {
  all: 'all',
  pending: 'pending',
  active: 'active',
  paused: 'paused'
}

export const NFT_YES_NO_OPTIONS = {
  yes: 'yes',
  no: 'no'
}

const buildNftTypeOptions = (t) => {
  return Object.keys(NFT_TYPES_OPTION_DATA).map((key) => ({
    value: key,
    label: t(`nft.nft-types.${NFT_TYPES_OPTION_DATA[key]}`)
  }))
}

const buildNftSortingOptions = (t) => {
  return Object.keys(NFT_SORTING_OPTIONS).map((key) => ({
    value: key,
    label: t(`nft.nft-sorting-types.${NFT_SORTING_OPTIONS[key]}`)
  }))
}

const buildNftStatusOptions = (t) => {
  return Object.keys(NFT_STATUS_OPTIONS).map((key) => ({
    value: key,
    label: t(`nft.nft-status-types.${NFT_STATUS_OPTIONS[key]}`)
  }))
}

const buildYesNoOptions = (t) => {
  return buildDropdownList(NFT_YES_NO_OPTIONS, 'nft.yes-no-options', t)
}

export {
  buildNftTypeOptions,
  buildNftSortingOptions,
  buildNftStatusOptions,
  buildYesNoOptions
}
